export enum LinkPositionTypeEnum {
	TOP = 'top',
	BOTTOM = 'bottom',
}
